import React, {useState} from "react";
import {LoginPayloadRequest, loginUser} from "../../Context/AuthProvider/AuthProviderActions";
import {useAuthDispatch, useAuthState} from "../../Context/AuthProvider/AuthProvider";
import { useNavigate } from "react-router-dom";
import { FormHelperText, ActionGroup, Form, InputGroup, Button, FormGroup, TextInput} from "@patternfly/react-core";
import { EyeSlashIcon, EyeIcon, ExclamationCircleIcon } from '@patternfly/react-icons';
import {useAlertDispatcherState} from "../../Context/AlertProvider/AlertProvider";
import {addAlert} from "../../Context/AlertProvider/AlertProviderActions";
import {useCookies} from "react-cookie";
import {APP_ID, COOKIE_NAME} from "../../Config/UrlRuotes";

export const DiazarLoginForm: React.FunctionComponent = (_props) => {
    const [username, setUserName] = useState<string>("")
    const [password, setPassword] = useState<string>("")
    const [company, setCompany] = useState<string>("")

    const [seePassword, setSeePassword] = useState<boolean>(false)

    const dispatch = useAuthDispatch()
    const alertDispatch = useAlertDispatcherState()

    const { loading, errorMessage } = useAuthState()

    let navigate = useNavigate();


    const [cookies, setCookie] = useCookies([COOKIE_NAME]);

    const addSessionCoockie = React.useCallback( (token:string)=>{
        let cookieObj = ( cookies[COOKIE_NAME] !== undefined) ? cookies[COOKIE_NAME] : []
        cookieObj = cookieObj.filter( val => val.id !== APP_ID )
        cookieObj.push( { id: APP_ID, token:token } )

        setCookie( COOKIE_NAME, cookieObj, { path:'/', domain:'diazar.com' } )
    }, [cookies, setCookie] )

    const handleLogin = React.useCallback( async ()=>{
        let payload:LoginPayloadRequest = { company:company, username:username, password:password}

        try {
            let responseLogin = await loginUser(payload, dispatch)
            if (!responseLogin || !responseLogin.response || !responseLogin.response.user || responseLogin.response.user.id <= 0) return

            addAlert('Autentificación exitosa', undefined,"success", alertDispatch )
            addSessionCoockie( responseLogin.response.token )
            navigate("/")

        } catch (error) {
            console.log(error)
        }


    }, [company, username, password, dispatch, navigate, alertDispatch, addSessionCoockie] )

    const isValidForm = React.useMemo<boolean>( () => {
        const isValidUsername = username.trim() !== ""
        const isValidCompany = company.trim() !== ""
        const isValidPassword = password.trim() !== ""

        const isLoading = ( loading !== undefined ) ? loading : false

        return !isLoading && isValidCompany && isValidUsername && isValidPassword

    }, [company, username, password, loading] )

    const helperText = React.useMemo( () => {
        if ( errorMessage === undefined ){
            return null
        }else{
            return (
                <FormHelperText isError={true} isHidden={false}>
                    <ExclamationCircleIcon />
                    &nbsp;{errorMessage}.
                </FormHelperText>
            )
        }
    }, [errorMessage] )


    const icoButton = React.useMemo( () => {
        if ( seePassword ){
            return <EyeSlashIcon />
        }else{
            return <EyeIcon />
        }
    }, [ seePassword ] )

    return (
        <React.Fragment>
            <div className="auth-wrapper">
                <div className="auth-inner">
                    <Form>
                        { helperText }
                        <FormGroup label="Clave" isRequired fieldId="login-clave">
                            <TextInput id="login-clave"
                                       type="text"
                                       placeholder="Clave de Usuario"
                                       value={username}
                                       onChange={ (value:string) => { setUserName( value ) } }
                            />
                        </FormGroup>
                        <FormGroup label="Contraseña" isRequired fieldId="login-password">
                            <InputGroup >
                                <TextInput id="login-password"
                                           type={ (seePassword) ? 'text' : 'password' }
                                           placeholder="Contraseña de Usuario"
                                           value={password}
                                           onChange={ (value:string) => setPassword(value) }
                                />
                                <Button variant="control"
                                        onClick={ () => setSeePassword( flag => !flag ) }
                                >
                                    { icoButton }
                                </Button>
                            </InputGroup>
                        </FormGroup>
                        <FormGroup label="Empresa" isRequired fieldId="login-company">
                            <TextInput id="login-company"
                                       type="text"
                                       placeholder="Empresa de Usuario"
                                       value={company}
                                       onChange={ (value:string) => setCompany(value) }
                            />
                        </FormGroup>

                        <ActionGroup>
                            <Button type="submit"
                                    onClick={ e => { e.preventDefault(); handleLogin() }}
                                    isBlock
                                    isDisabled={ !isValidForm }
                                    isLoading={ ( loading !== undefined ) ? loading : false }
                            >
                                Enviar
                            </Button>
                        </ActionGroup>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    );
}
